import { render, staticRenderFns } from "./blockchain_d.vue?vue&type=template&id=3c59a1fe&scoped=true"
import script from "./blockchain_d.vue?vue&type=script&lang=js"
export * from "./blockchain_d.vue?vue&type=script&lang=js"
import style0 from "./blockchain_d.vue?vue&type=style&index=0&id=3c59a1fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c59a1fe",
  null
  
)

export default component.exports